import React from "react";
import {makeApiUrl} from '../../../helpers/makeApiUrl';
import {handleResponse} from "../../../helpers/handleResponse";
import {authHeader} from "../../../helpers/authHeader";
import {Spinner} from "../../Spinner";
import {requestOption} from "../../../helpers/requestOption";
import Link from "../Link";

class SearchHistory extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            queries: [],
            loading: true,
        };
    }

    componentDidMount() {
        fetch(makeApiUrl('search/last/10'), requestOption())
            .then(handleResponse)
            .then(response => {
                this.setState({
                    queries: response.queries,
                    loading: false,
                })
            });
    }

    render() {
        let items;

        if (this.state.loading) {
            items = <Spinner/>;
        } else if (this.state.queries.length) {
            items = this.state.queries.map(function(query, index) {
                const finalQuery = [];
                const queryElements = query.name.split(' &larr; ');

                queryElements.forEach(function(queryElement, queryIndex) {
                    finalQuery.push(<span key={queryIndex}>{queryElement}</span>);

                    if (queryElements.length - 1 != queryIndex) {
                        finalQuery.push(<span dangerouslySetInnerHTML={{__html: ' &larr; '}} key="arrow"></span>);
                    }
                });

                return <Link to={"/product/" + query.name} key={index} >
                    {finalQuery}
                </Link>
            });

            items.push(<Link to="/search-history" key="link" className="btn btn-primary">Więcej wyszukiwań</Link>);
        } else {
            items = 'Brak historii przeglądania.';
        }

        return <div className="box">
            <div className="header">
                <h3>Historia wyszukiwania</h3>
            </div>
            <div className="content search-history">
                {items}
            </div>
        </div>
    }
}

export default (SearchHistory);